enum ScreenSharing {
  extensionElementId = 'ls-extension-installed',
  extensionEventName = 'screenShareEvent', // screenShareEventWithOptions
  extensionReinstall = 'reinstallEvent',
  extensionRequestName = 'requestScreenShareWithSources', // 'requestScreenShare' = screen, app window / 'requestScreenShareWithSources' = scrren, app window, chrome tab
  extensionUrl = 'https://chrome.google.com/webstore/detail/pkdaplneajgbalnnmaoflooakgijjkhc'
}
export default ScreenSharing;



// WEBPACK FOOTER //
// ./src/constants/ScreenSharing.ts